export default __webpack_public_path__ + "static/media/gysr.e5042c9a.png";